export function mergeOptions(options: any, defaults: any) {
  for(const key in defaults) {
    if(typeof options[key] === 'undefined') {
      options[key] = defaults[key];
    }
  }
  return options;
}
